module.exports = __webpack_public_path__ + "img/如何插入图片.9b5480a5.gif";